//
//
//
//
//
//

var script = {
  props: {
    active: {
      type: Number,
    },

    isBox: {
      type: Boolean,
    },

    isExpandable: {
      type: Boolean,
    },

    level: {
      type: Number,
    },

    isCompact: {
      type: Boolean,
      default: false,
    },

    disableAnimate: {
      type: Boolean,
      default: false,
    },
  },

  data: function data() {
    return {
      Accordion: {
        count: 0,
        active: this.active,
        isBox: this.isBox,
        isExpandable: this.isExpandable,
        level: this.level,
        isCompact: this.isCompact,
      },
    };
  },

  provide: function provide() {
    return {
      Accordion: this.Accordion,
    };
  },

  watch: {
    active: function active(value) {
      this.Accordion.active = value;
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ul",
    {
      class: [
        "vs-accordion",
        { "vs-accordion--disable-animate": _vm.disableAnimate }
      ]
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-2556d36c_0", { source: ".vs-accordion {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.vs-accordion__item:last-child {\n  border-bottom: none;\n}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1 = {
  props: {},

  inject: ['Accordion'],

  data: function data() {
    return {
      index: null,
      isBox: false,
      isExpandable: false,
      isExpandableToggle: false,
      level: null,
      hasNonClickableContent: this.$slots['accordion-non-clickable'],
    };
  },

  computed: {
    visible: function visible() {
      return this.index == this.Accordion.active;
    },
  },

  created: function created() {
    this.index = this.Accordion.count++;
    this.isBox = this.Accordion.isBox;
    this.level = this.Accordion.level;
    this.isCompact = this.Accordion.isCompact;
    this.isExpandable = this.Accordion.isExpandable;
    if (this.isExpandable) {
      this.isExpandableToggle = this.index === this.Accordion.active;
    }
  },

  methods: {
    open: function open() {
      if (this.isExpandable) {
        this.isExpandableToggle = !this.isExpandableToggle;
        this.$emit('change', { visible: this.isExpandableToggle, index: this.index });
        return;
      }
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }
      this.$emit('change', { visible: this.visible, index: this.index });
    },

    start: function start(el) {
      el.style.height = el.scrollHeight + 'px';
    },

    onEnter: function onEnter(el) {
      this.$emit('open');
      el.style.height = '';
    },

    onLeave: function onLeave(el) {
      this.$emit('hide');
      el.style.height = '';
    },
  },
};

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    {
      staticClass: "vs-accordion__item",
      class: [
        { "vs-accordion--box": _vm.isBox },
        { "vs-accordion--compact": _vm.isCompact },
        {
          "vs-accordion__active": _vm.isExpandable
            ? _vm.isExpandableToggle
            : _vm.visible
        }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "vs-accordion__trigger",
          attrs: { role: "heading", "aria-level": _vm.level },
          on: { click: _vm.open }
        },
        [
          _c(
            "button",
            {
              staticClass: "vs-accordion__button",
              attrs: {
                id: "accordion-" + (_vm.index + 1),
                tabindex: "0",
                "aria-expanded": _vm.visible ? "true" : "false"
              }
            },
            [_vm._t("accordion-trigger")],
            2
          ),
          _vm._v(" "),
          _vm._t("accordion-icon", [
            _c(
              "svg",
              {
                class: [
                  "vs-accordion--icon",
                  {
                    "vs-accordion--icon-active": _vm.isExpandable
                      ? _vm.isExpandableToggle
                      : _vm.visible
                  }
                ],
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 16 16",
                  focusable: "false",
                  role: "presentation"
                }
              },
              [
                _c("path", {
                  attrs: {
                    fill: "currentColor",
                    d:
                      "M12.688 5.61a.5.5 0 01.69.718l-.066.062-5 4a.5.5 0 01-.542.054l-.082-.054-5-4a.5.5 0 01.55-.83l.074.05L8 9.359l4.688-3.75z"
                  }
                })
              ]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasNonClickableContent
        ? _c(
            "div",
            { staticClass: "vs-accordion__non-clickable" },
            [_vm._t("accordion-non-clickable")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "vs-accordion" },
          on: {
            enter: _vm.start,
            "after-enter": _vm.onEnter,
            "before-leave": _vm.start,
            "after-leave": _vm.onLeave
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isExpandable
                    ? _vm.isExpandableToggle
                    : _vm.visible,
                  expression: "isExpandable ? isExpandableToggle : visible"
                }
              ],
              staticClass: "vs-accordion__content",
              attrs: {
                "aria-labelledby": "accordion-" + (_vm.index + 1),
                "aria-hidden": _vm.visible ? "false" : "true"
              }
            },
            [
              _c(
                "div",
                { staticClass: "vs-accordion__content-wrapper" },
                [_vm._t("default")],
                2
              )
            ]
          )
        ]
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = function (inject) {
    if (!inject) { return }
    inject("data-v-1eccf14a_0", { source: ".vs-accordion {\n  --vs-accordion-border-color: #d8dcde;\n  --vs-accordion-border-radius: 4px;\n  --vs-accordion-padding: 20px;\n  --vs-accordion-compact-padding: 10px;\n}\n.vs-accordion__item {\n  border-bottom: 1px solid var(--vs-accordion-border-color);\n  position: relative;\n}\n.vs-accordion__item.vs-accordion--box {\n  border: 1px solid var(--vs-accordion-border-color);\n  border-radius: var(--vs-accordion-border-radius);\n  margin-bottom: 10px;\n}\n.vs-accordion__trigger {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--vs-accordion-padding);\n  transition: all 0.25s ease-in-out 0s;\n}\n.vs-accordion__non-clickable {\n  padding: 0 var(--vs-accordion-padding) var(--vs-accordion-padding) var(--vs-accordion-padding);\n}\n.vs-accordion--compact .vs-accordion__trigger {\n  padding: var(--vs-accordion-compact-padding);\n}\n.vs-accordion--compact .vs-accordion__non-clickable {\n  padding: 0 var(--vs-accordion-compact-padding) var(--vs-accordion-compact-padding) var(--vs-accordion-compact-padding);\n}\n.vs-accordion--compact .vs-accordion__content-wrapper {\n  padding: 0 var(--vs-accordion-compact-padding) var(--vs-accordion-compact-padding);\n}\n.vs-accordion--icon-active {\n  transform: rotate(180deg);\n}\n.vs-accordion__button {\n  background: transparent;\n  border: 0;\n  outline: none;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n}\n.vs-accordion--icon {\n  flex: 0 0 16px;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n  color: #68737d;\n  transition: all 0.25s ease-in-out 0s;\n}\n.vs-accordion.vs-accordion--disable-animate .vs-accordion--icon {\n  transition: none;\n}\n.vs-accordion__content-wrapper {\n  padding: 0 var(--vs-accordion-padding) var(--vs-accordion-padding);\n}\n.vs-accordion:not(.vs-accordion--disable-animate) .vs-accordion-enter-active, .vs-accordion:not(.vs-accordion--disable-animate) .vs-accordion-leave-active {\n  will-change: height, opacity;\n  transition: height 0.3s ease, opacity 0.3s ease;\n  overflow: hidden;\n}\n.vs-accordion:not(.vs-accordion--disable-animate) .vs-accordion-enter, .vs-accordion:not(.vs-accordion--disable-animate) .vs-accordion-leave-to {\n  height: 0 !important;\n  opacity: 0;\n}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    createInjector,
    undefined,
    undefined
  );

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('VsAccordion', __vue_component__);
  Vue.component('VsAccordionItem', __vue_component__$1);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default __vue_component__;
export { __vue_component__ as VsAccordion, __vue_component__$1 as VsAccordionItem, install };
